import React from 'react';

interface IProps {
  fillColor?: string;
  style?: any;
}

export const ArrowLongIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="76" height="12" viewBox="0 0 76 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M75.5303 6.53032C75.8232 6.23743 75.8232 5.76256 75.5303 5.46966L70.7574 0.696693C70.4645 0.4038 69.9896 0.4038 69.6967 0.696693C69.4038 0.989587 69.4038 1.46446 69.6967 1.75735L73.9393 5.99999L69.6967 10.2426C69.4038 10.5355 69.4038 11.0104 69.6967 11.3033C69.9896 11.5962 70.4645 11.5962 70.7574 11.3033L75.5303 6.53032ZM6.55671e-08 6.75L75 6.74999L75 5.24999L-6.55671e-08 5.25L6.55671e-08 6.75Z" fill="#8D8D8D"/>
    </svg>
  )
}